import { memoizeFunction } from '@agilepoint/utils-common';
import React from 'react';
import { IEditor } from 'roosterjs-editor-types';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../types';
import { selectThemeSemantics } from '../../../styling';
import { IToolbarProps, WithToolbar } from '../../toolbar';
import { Actions } from './actions';
import { FormatStateProvider, ToolBarActionContext } from './context';
import { IChangeDetector } from '../plugins';

interface IEditorToolbarProps extends IBaseComponentProps<HTMLDivElement>, Omit<IToolbarProps, 'remoteContainerRef'> {
    editor?: IEditor;
    hidden?: boolean;
    changeDetector: IChangeDetector;
}

const getProviderValue = memoizeFunction((editor: IEditor) => ({ editor }));

const StyledToolbar = styled(WithToolbar)`
    border-bottom: 1px solid ${selectThemeSemantics(({ palette }) => palette.neutralTertiary)};
`;

export function EditorToolbar(props: IEditorToolbarProps) {
    const { editor, hidden, changeDetector, ...rest } = props;

    if (!editor || hidden) {
        return null;
    }

    return (
        <ToolBarActionContext.Provider value={getProviderValue(editor)}>
            <FormatStateProvider editor={editor} changeDetector={changeDetector}>
                <StyledToolbar overflow="wrap" height={35} {...rest}>
                    {Actions.map((Action, i) => <Action key={Action.displayName ?? Action.name} order={i} />)}
                </StyledToolbar>
            </FormatStateProvider>
        </ToolBarActionContext.Provider>
    );
}
